import { LogLevel, LogSink } from "./models";

export abstract class LoggingService {
  abstract webLogging(logEntry: { lvl: LogLevel; message: string }): any;
}

export interface AbstractServiceLogger extends LogSink {}
export abstract class AbstractServiceLogger {}
